import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';

export const isValidZipFormat = (zip: string) => /^\d{5}$/.test(zip);

export const useZipCoords = (zip: string) => {
  const validZip = isValidZipFormat(zip);

  const [debouncedZip] = useDebounce(zip, 500);

  const { data, isError, isLoading } = useQuery({
    queryKey: ['zip-coords', debouncedZip],
    enabled: validZip,
    queryFn: async () => {
      const res = await fetch(
        `/api/geo/geocode?${new URLSearchParams({ postalCode: debouncedZip, country: 'US' })}`
      );

      if (!res.ok) {
        throw new Error();
      }

      const coords = (await res.json()).coordinates;
      return { lat: coords[0], lng: coords[1] };
    },
  });

  const debounceWaiting = debouncedZip !== zip;

  const err = !validZip || isError;
  return {
    coords: err ? undefined : data,
    isError: err,
    isLoading: debounceWaiting || isLoading,
  };
};
